import { Component, Input, ElementRef, Renderer2, HostListener, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Este componente se utiliza como base al resto de Content Loaders: [Card Content Loader]{@link CardContentLoaderComponent},
 * [Line Content Loader]{@link LineContentLoaderComponent}, [Form Content Loader]{@link FormContentLoaderComponent} y
 * [Document Content Loader]{@link DocumentContentLoaderComponent}.
 * No es utilizable para HTML, pero tiene algunas propiedades que se comparten entre todos los Content Loader que estan definidas aquí.
 *
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function ContentLoaderComponent__svg_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r0.animationValues[0])("dur", ctx_r0.speed);
} }
function ContentLoaderComponent__svg_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r1.animationValues[1])("dur", ctx_r1.speed);
} }
function ContentLoaderComponent__svg_ng_container_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "animate", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("values", ctx_r2.animationValues[2])("dur", ctx_r2.speed);
} }
const _c0 = function (a0) { return { fill: a0 }; };
const _c1 = ["*"];
const _c2 = function (a0) { return { "margin-top.px": a0 }; };
function FormContentLoaderComponent_fieldset_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "fieldset", 3);
    ɵngcc0.ɵɵelement(1, "line-content-loader", 4);
    ɵngcc0.ɵɵelement(2, "div", 5);
    ɵngcc0.ɵɵelement(3, "line-content-loader", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lineSeparation", ctx_r0.lineSeparation)("lines", 1)("lineHeight", ctx_r0.lineHeight * 0.8)("lineWidth", ctx_r0.lineWidth / 3)("animate", ctx_r0.animate)("width", ctx_r0.width)("height", ctx_r0.totalHeight)("speed", ctx_r0.speed)("preserveAspectRatio", ctx_r0.preserveAspectRatio)("primaryColor", ctx_r0.primaryColor)("secondaryColor", ctx_r0.secondaryColor)("primaryOpacity", ctx_r0.primaryOpacity)("secondaryColor", ctx_r0.secondaryColor)("uniqueKey", ctx_r0.uniqueKey);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(29, _c2, ctx_r0.lineSeparation));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("lineSeparation", ctx_r0.lineSeparation)("lines", ctx_r0.lines)("lineHeight", ctx_r0.lineHeight)("lineWidth", ctx_r0.lineWidth)("animate", ctx_r0.animate)("width", ctx_r0.width)("height", ctx_r0.totalHeight)("speed", ctx_r0.speed)("preserveAspectRatio", ctx_r0.preserveAspectRatio)("primaryColor", ctx_r0.primaryColor)("secondaryColor", ctx_r0.secondaryColor)("primaryOpacity", ctx_r0.primaryOpacity)("secondaryColor", ctx_r0.secondaryColor)("uniqueKey", ctx_r0.uniqueKey);
} }
function FormContentLoaderComponent_fieldset_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fieldset", 6);
} }
function LineContentLoaderComponent__svg_rect_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "rect");
} if (rf & 2) {
    const line_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("x", ctx_r0.lineX)("y", ctx_r0.getLineY(line_r1))("width", ctx_r0.lineWidth)("height", ctx_r0.lineHeight);
} }
function CardContentLoaderComponent__svg_circle_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "circle");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("cx", ctx_r0.radius)("cy", ctx_r0.iconY)("r", ctx_r0.radius);
} }
function CardContentLoaderComponent__svg_rect_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelement(0, "rect");
} if (rf & 2) {
    const line_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("x", ctx_r1.lineX)("y", ctx_r1.getLineY(line_r2))("width", ctx_r1.lineWidth)("height", ctx_r1.lineHeight);
} }
class ContentLoaderComponent {
    constructor() {
        //#region Privates
        this._animate = true;
        this._width = 400;
        this._height = 130;
        this._speed = 2;
        // private _preserveAspectRatio = 'none';
        this._preserveAspectRatio = 'xMaxYMid meet';
        this._primaryColor = '#EAEAEA';
        this._secondaryColor = '#F9F9F9';
        this._primaryOpacity = 0.5;
        this._secondaryOpacity = 0.5;
        this._idClip = this.uid();
        this._idGradient = this.uid();
        /** @ignore */
        this.animationValues = ['-3; 1', '-2; 2', '-1; 3'];
        //#endregion
    }
    //#endregion
    //#region Functions
    uid() {
        return Math.random().toString(36).substring(2);
    }
    //#endregion
    //#region Getters & Setters
    /** @ignore */
    get idClip() {
        return this._idClip;
    }
    /** @ignore */
    get idGradient() {
        return this._idGradient;
    }
    /**
     * Permite consultar si la animación está activada o no. De manera predeterminada está activada
     *
     * @return
     */
    get animate() {
        return this._animate;
    }
    /**
     * Permite activar o desactivar la animación del componente. De manera predeterminada está activada
     *
     * @param value Valor que activa o desactiva la animación
     * @return
     */
    set animate(value) {
        this._animate = value;
    }
    /**
     * Permite obtener la anchura total del componente
     *
     * @return
     */
    get width() {
        return this._width;
    }
    /**
     * Permite definir la anchura total del componente
     *
     * @param value La anchura total del componente
     * @return
     */
    set width(value) {
        this._width = value;
    }
    /**
     * Permite obtener la altura total del componente
     *
     * @return
     */
    get height() {
        return this._height;
    }
    /**
     * Permite definir la altura total del componente
     *
     * @param value La altura total del componente
     * @return
     */
    set height(value) {
        this._height = value;
    }
    /**
     * Permite obtener la velocidad de animación del componente
     *
     * @return
     */
    get speed() {
        return this._speed;
    }
    /**
     * Permite definir la velocidad de animación del componente
     *
     * @param value La velocidad de animación del componente
     * @return
     */
    set speed(value) {
        this._speed = value;
    }
    /** @ignore */
    get preserveAspectRatio() {
        return this._preserveAspectRatio;
    }
    /** @ignore */
    set preserveAspectRatio(value) {
        this._preserveAspectRatio = value;
    }
    /**
     * Permite obtener el color principal base del componente
     *
     * @return
     */
    get primaryColor() {
        return this._primaryColor;
    }
    /**
     * Permite definir el color principal base del componente
     *
     * @param value El color principal base del componente
     * @return
     */
    set primaryColor(value) {
        this._primaryColor = value;
    }
    /**
     * Permite obtener el color secundario del componente, que es el que pasa por encima del color base cuando hay animación
     *
     * @return
     */
    get secondaryColor() {
        return this._secondaryColor;
    }
    /**
     * Permite definir el color secundario del componente, que es el que pasa por encima del color base cuando hay animación
     *
     * @param value El color secundario del componente
     * @return
     */
    set secondaryColor(value) {
        this._secondaryColor = value;
    }
    /**
     * Permite obtener la opacidad del color principal del componente
     *
     * @return
     */
    get primaryOpacity() {
        return this._primaryOpacity;
    }
    /**
     * Permite definir la opacidad del color principal del componente
     *
     * @param value La opacidad del color principal del componente
     * @return
     */
    set primaryOpacity(value) {
        this._primaryOpacity = value;
    }
    /**
     * Permite obtener la opacidad del color secundario del componente
     *
     * @return
     */
    get secondaryOpacity() {
        return this._secondaryOpacity;
    }
    /**
     * Permite definir la opacidad del color secundario del componente
     *
     * @param value La opacidad del color secundario del componente
     * @return
     */
    set secondaryOpacity(value) {
        this._secondaryOpacity = value;
    }
    /**
     * Permite obtener el identificador único del content loader
     *
     * @return
     */
    get uniqueKey() {
        return this._uniqueKey;
    }
    /**
     * Permite definir el identificador único del content loader
     *
     * @param value El identificador único del content loader
     * @return
     */
    set uniqueKey(value) {
        this._uniqueKey = value;
    }
}
ContentLoaderComponent.ɵfac = function ContentLoaderComponent_Factory(t) { return new (t || ContentLoaderComponent)(); };
ContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContentLoaderComponent, selectors: [["content-loader"]], inputs: { animate: "animate", width: "width", height: "height", speed: "speed", preserveAspectRatio: "preserveAspectRatio", primaryColor: "primaryColor", secondaryColor: "secondaryColor", primaryOpacity: "primaryOpacity", secondaryOpacity: "secondaryOpacity", uniqueKey: "uniqueKey" }, ngContentSelectors: _c1, decls: 12, vars: 22, consts: [["version", "1.1"], ["x", "0", "y", "0", 3, "ngStyle"], ["offset", "0%"], [4, "ngIf"], ["offset", "50%"], ["offset", "100%"], ["attributeName", "offset", "s", "", "repeatCount", "indefinite"]], template: function ContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelement(1, "rect", 1);
        ɵngcc0.ɵɵelementStart(2, "defs");
        ɵngcc0.ɵɵelementStart(3, "clipPath");
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "linearGradient");
        ɵngcc0.ɵɵelementStart(6, "stop", 2);
        ɵngcc0.ɵɵtemplate(7, ContentLoaderComponent__svg_ng_container_7_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "stop", 4);
        ɵngcc0.ɵɵtemplate(9, ContentLoaderComponent__svg_ng_container_9_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "stop", 5);
        ɵngcc0.ɵɵtemplate(11, ContentLoaderComponent__svg_ng_container_11_Template, 2, 2, "ng-container", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattributeInterpolate2("viewBox", "0 0 ", ctx.width, " ", ctx.height, "");
        ɵngcc0.ɵɵattribute("preserveAspectRatio", ctx.preserveAspectRatio)("width", ctx.width)("height", ctx.height);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattributeInterpolate1("clip-path", "url(#", ctx.idClip, ")");
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(20, _c0, "url(#" + ctx.idGradient + ")"));
        ɵngcc0.ɵɵattribute("width", ctx.width)("height", ctx.height);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.idClip);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("id", ctx.idGradient);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.primaryColor)("stop-opacity", ctx.primaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.secondaryColor)("stop-opacity", ctx.secondaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("stop-color", ctx.primaryColor)("stop-opacity", ctx.primaryOpacity);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.animate);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf], styles: ["[_nghost-%COMP%]{ height: 100%; }"] });
ContentLoaderComponent.propDecorators = {
    animate: [{ type: Input }],
    width: [{ type: Input }],
    height: [{ type: Input }],
    speed: [{ type: Input }],
    preserveAspectRatio: [{ type: Input }],
    primaryColor: [{ type: Input }],
    secondaryColor: [{ type: Input }],
    primaryOpacity: [{ type: Input }],
    secondaryOpacity: [{ type: Input }],
    uniqueKey: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'content-loader',
                template: "<svg attr.viewBox=\"0 0 {{width}} {{height}}\" version=\"1.1\" [attr.preserveAspectRatio]=\"preserveAspectRatio\"\r\n  [attr.width]=\"width\" [attr.height]=\"height\">\r\n  <rect attr.clip-path=\"url(#{{ idClip }})\" [ngStyle]=\"{fill: 'url(#' + idGradient + ')' }\" x=\"0\" y=\"0\" [attr.width]=\"width\" [attr.height]=\"height\" />\r\n  <defs>\r\n    <clipPath [attr.id]=\"idClip\">\r\n      <ng-content></ng-content>\r\n    </clipPath>\r\n    <linearGradient [attr.id]=\"idGradient\">\r\n      <stop offset=\"0%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\r\n        <ng-container *ngIf=\"animate\">\r\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[0]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\r\n        </ng-container>\r\n      </stop>\r\n\r\n      <stop offset=\"50%\" [attr.stop-color]=\"secondaryColor\" [attr.stop-opacity]=\"secondaryOpacity\">\r\n        <ng-container *ngIf=\"animate\">\r\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[1]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\r\n        </ng-container>\r\n      </stop>\r\n\r\n      <stop offset=\"100%\" [attr.stop-color]=\"primaryColor\" [attr.stop-opacity]=\"primaryOpacity\">\r\n        <ng-container *ngIf=\"animate\">\r\n          <animate attributeName=\"offset\" [attr.values]=\"animationValues[2]\" attr.dur={{speed}} s repeatCount=\"indefinite\" />\r\n        </ng-container>\r\n      </stop>\r\n    </linearGradient>\r\n  </defs>\r\n</svg>",
                styles: [':host{ height: 100%; }']
            }]
    }], function () { return []; }, { animate: [{
            type: Input
        }], width: [{
            type: Input
        }], height: [{
            type: Input
        }], speed: [{
            type: Input
        }], preserveAspectRatio: [{
            type: Input
        }], primaryColor: [{
            type: Input
        }], secondaryColor: [{
            type: Input
        }], primaryOpacity: [{
            type: Input
        }], secondaryOpacity: [{
            type: Input
        }], uniqueKey: [{
            type: Input
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un content loader de tipo formulario
 *
 * @example
 * <form-content-loader
 *  [lineSeparation]="30"
 *  [lines]="4"
 *  [blocks]="3"
 *  [lineWidth]="400"
 *  [lineHeight]="20">
 * </form-content-loader>
 *
 */
class FormContentLoaderComponent extends ContentLoaderComponent {
    //#endregion
    //#region Constructor
    /** @ignore */
    constructor() {
        super();
        //#region Privates
        this._lineSeparation = 40;
        this._lines = 4;
        this._blocks = 1;
        this._lineWidth = 400;
        this._lineHeight = 20;
        this._lineX = 0;
        this._totalHeight = 0;
    }
    //#endregion
    //#region Hooks
    ngOnInit() {
        this._totalLines = Array(this.lines).fill(0).map((x, i) => i + 1);
        this._totalBlocks = Array(this.blocks).fill(0).map((x, i) => i + 1);
        if (this.blocks > 2) {
            this._totalPlaceholders = Array(this.blocks - 2).fill(0).map((x, i) => i + 1);
        }
        this._totalHeight = this.getTotalHeight();
        this.width = this.lineWidth;
    }
    //#endregion
    //#region Functions
    getTotalHeight() {
        return (this.lineSeparation * (this.lines - 1)) + (this.lineHeight * this.lines);
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite obtener la distancia de separación que hay entre lineas
     *
     * @return
     */
    get lineSeparation() {
        return this._lineSeparation;
    }
    /**
     * Permite definir la distancia de separación que hay entre lineas
     *
     * @param value La distancia de separación que hay entre lineas
     * @return
     */
    set lineSeparation(value) {
        this._lineSeparation = value;
    }
    /**
     * Permite obtener el ancho de las lineas
     *
     * @return
     */
    get lineWidth() {
        return this._lineWidth;
    }
    /**
     * Permite definir el ancho de las lineas
     *
     * @param value El ancho de las lineas
     * @return
     */
    set lineWidth(value) {
        this._lineWidth = value;
    }
    /**
     * Permite obtener la altura de las lineas
     *
     * @return
     */
    get lineHeight() {
        return this._lineHeight;
    }
    /**
     * Permite definir la altura de las lineas
     *
     * @param value La altura de las lineas
     * @return
     */
    set lineHeight(value) {
        this._lineHeight = value;
    }
    /**
     * Permite obtener el número de lineas que tiene cada uno de los bloques
     * @return
     */
    get lines() {
        return this._lines;
    }
    /**
     * Permite definir el número de lineas que tiene cada uno de los bloques
     *
     * @param value El número de lineas que tiene cada uno de los bloques
     * @return
     */
    set lines(value) {
        this._lines = value;
    }
    /**
     * Permite obtener el número de bloques totales que tiene el componente, cada uno de los cuales tiene el número de lineas indicado en el Input 'lines'
     *
     * @return
     */
    get blocks() {
        return this._blocks;
    }
    /**
     * Permite definir el número de bloques totales que tiene el componente, cada uno de los cuales tiene el número de lineas indicado en el Input 'lines'
     *
     * @param value El número de bloques totales que tiene el componente
     * @return
     */
    set blocks(value) {
        this._blocks = value;
    }
    /** @ignore */
    get lineX() {
        return this._lineX;
    }
    /** @ignore */
    get totalHeight() {
        return this._totalHeight;
    }
    /** @ignore */
    get totalBlocks() {
        return this._totalBlocks;
    }
    /** @ignore */
    get totalPlaceholders() {
        return this._totalPlaceholders;
    }
}
FormContentLoaderComponent.ɵfac = function FormContentLoaderComponent_Factory(t) { return new (t || FormContentLoaderComponent)(); };
FormContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormContentLoaderComponent, selectors: [["form-content-loader"]], inputs: { lineSeparation: "lineSeparation", lineWidth: "lineWidth", lineHeight: "lineHeight", lines: "lines", blocks: "blocks" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 2, consts: [[1, "rowAvailable", "fluidContent"], ["class", "fluidBox verticalLayout", 4, "ngFor", "ngForOf"], ["class", "fluidPlaceholder", 4, "ngFor", "ngForOf"], [1, "fluidBox", "verticalLayout"], [3, "lineSeparation", "lines", "lineHeight", "lineWidth", "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], [3, "ngStyle"], [1, "fluidPlaceholder"]], template: function FormContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormContentLoaderComponent_fieldset_1_Template, 4, 31, "fieldset", 1);
        ɵngcc0.ɵɵtemplate(2, FormContentLoaderComponent_fieldset_2_Template, 1, 0, "fieldset", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalBlocks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalPlaceholders);
    } }, directives: function () { return [ɵngcc1.NgForOf, LineContentLoaderComponent, ɵngcc1.NgStyle]; }, encapsulation: 2 });
/** @nocollapse */
FormContentLoaderComponent.ctorParameters = () => [];
FormContentLoaderComponent.propDecorators = {
    lineSeparation: [{ type: Input }],
    lineWidth: [{ type: Input }],
    lineHeight: [{ type: Input }],
    lines: [{ type: Input }],
    blocks: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'form-content-loader',
                template: "<div class=\"rowAvailable fluidContent\">\r\n  <fieldset *ngFor=\"let block of totalBlocks\" class=\"fluidBox verticalLayout\">\r\n    <line-content-loader [lineSeparation]=\"lineSeparation\" [lines]=\"1\" [lineHeight]=\"lineHeight*0.8\" [lineWidth]=\"lineWidth/3\"\r\n      [animate]=\"animate\" [width]=\"width\" [height]=\"totalHeight\" [speed]=\"speed\" [preserveAspectRatio]=\"preserveAspectRatio\"\r\n      [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" [primaryOpacity]=\"primaryOpacity\"\r\n      [secondaryColor]=\"secondaryColor\" [uniqueKey]=\"uniqueKey\"></line-content-loader>\r\n    <!-- <line-content-loader lineSeparation=\"0\" [lines]=\"1\" [lineHeight]=\"lineSeparation\" lineWidth=\"0\"></line-content-loader> -->\r\n    <div [ngStyle]=\"{'margin-top.px': lineSeparation }\"></div>\r\n    <line-content-loader [lineSeparation]=\"lineSeparation\" [lines]=\"lines\" [lineHeight]=\"lineHeight\" [lineWidth]=\"lineWidth\"\r\n      [animate]=\"animate\" [width]=\"width\" [height]=\"totalHeight\" [speed]=\"speed\" [preserveAspectRatio]=\"preserveAspectRatio\"\r\n      [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" [primaryOpacity]=\"primaryOpacity\"\r\n      [secondaryColor]=\"secondaryColor\" [uniqueKey]=\"uniqueKey\"></line-content-loader>\r\n  </fieldset>\r\n  <fieldset *ngFor=\"let placeholder of totalPlaceholders\" class=\"fluidPlaceholder\"></fieldset>\r\n</div>"
            }]
    }], function () { return []; }, { lineSeparation: [{
            type: Input
        }], lineWidth: [{
            type: Input
        }], lineHeight: [{
            type: Input
        }], lines: [{
            type: Input
        }], blocks: [{
            type: Input
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un content loader de tipo line
 *
 * @example
 * <line-content-loader
 *  [lineSeparation]="lineSeparation"
 *  [lines]="lines"
 *  [lineHeight]="lineHeight"
 *  [lineWidth]="lineWidth">
 * </line-content-loader>
 *
 */
class LineContentLoaderComponent extends ContentLoaderComponent {
    //#endregion
    //#region Constructor
    /** @ignore */
    constructor(_el, _renderer) {
        super();
        this._el = _el;
        this._renderer = _renderer;
        //#region Privates
        this._lineSeparation = 28;
        this._lines = 4;
        this._lineWidth = null;
        this._lineHeight = 10;
        this._lineX = 0;
        this._totalHeight = 0;
        this._inputLineWidth = false;
    }
    //#endregion
    //#region Hooks
    ngOnInit() {
        this._totalLines = Array(this.lines).fill(0).map((x, i) => i + 1);
        this._totalHeight = this.getTotalHeight();
        if (this.lineWidth === null) {
            this.setLineWidth();
        }
        else {
            this._inputLineWidth = true;
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.setLineWidth();
        });
    }
    //#endregion
    //#region Functions
    getTotalHeight() {
        return (this.lineSeparation * (this.lines - 1)) + (this.lineHeight * this.lines);
    }
    //#endregion
    /** @ignore */
    getLineY(numberLine) {
        return (numberLine - 1) * (this.lineSeparation + this.lineHeight);
    }
    /** @ignore */
    setLineWidth() {
        if (!this._inputLineWidth) {
            this.lineWidth = this._el.nativeElement.parentNode.clientWidth;
        }
    }
    //#region Getters & Setters
    /**
     * Permite obtener la distancia de separación que hay entre lineas
     *
     * @return
     */
    get lineSeparation() {
        return this._lineSeparation;
    }
    /**
     * Permite definir la distancia de separación que hay entre lineas
     *
     * @param value La distancia de separación que hay entre lineas
     * @return
     */
    set lineSeparation(value) {
        this._lineSeparation = value;
    }
    /**
     * Permite obtener el ancho de las lineas
     *
     * @return
     */
    get lineWidth() {
        return this._lineWidth;
    }
    /**
     * Permite definir el ancho de las lineas
     *
     * @param value El ancho de las lineas
     * @return
     */
    set lineWidth(value) {
        this._lineWidth = value;
    }
    /**
     * Permite obtener la altura de las lineas
     *
     * @return
     */
    get lineHeight() {
        return this._lineHeight;
    }
    /**
     * Permite definir la altura de las lineas
     *
     * @param value La altura de las lineas
     * @return
     */
    set lineHeight(value) {
        this._lineHeight = value;
    }
    /**
     * Permite obtener el número de lineas
     * @return
     */
    get lines() {
        return this._lines;
    }
    /**
     * Permite definir el número de lineas
     *
     * @param value El número de lineas
     * @return
     */
    set lines(value) {
        this._lines = value;
    }
    /** @ignore */
    get lineX() {
        return this._lineX;
    }
    /** @ignore */
    get totalHeight() {
        return this._totalHeight;
    }
    /** @ignore */
    get totalLines() {
        return this._totalLines;
    }
}
LineContentLoaderComponent.ɵfac = function LineContentLoaderComponent_Factory(t) { return new (t || LineContentLoaderComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
LineContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LineContentLoaderComponent, selectors: [["line-content-loader"]], hostBindings: function LineContentLoaderComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function LineContentLoaderComponent_resize_HostBindingHandler() { return ctx.setLineWidth(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { lineWidth: "lineWidth", lineSeparation: "lineSeparation", lineHeight: "lineHeight", lines: "lines" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 11, consts: [[3, "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], [4, "ngFor", "ngForOf"]], template: function LineContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "content-loader", 0);
        ɵngcc0.ɵɵtemplate(1, LineContentLoaderComponent__svg_rect_1_Template, 1, 4, "rect", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("animate", ctx.animate)("width", ctx.lineWidth)("height", ctx.totalHeight)("speed", ctx.speed)("preserveAspectRatio", ctx.preserveAspectRatio)("primaryColor", ctx.primaryColor)("secondaryColor", ctx.secondaryColor)("primaryOpacity", ctx.primaryOpacity)("secondaryColor", ctx.secondaryColor)("uniqueKey", ctx.uniqueKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalLines);
    } }, directives: [ContentLoaderComponent, ɵngcc1.NgForOf], encapsulation: 2 });
/** @nocollapse */
LineContentLoaderComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
LineContentLoaderComponent.propDecorators = {
    setLineWidth: [{ type: HostListener, args: ['window:resize',] }],
    lineSeparation: [{ type: Input }],
    lineWidth: [{ type: Input }],
    lineHeight: [{ type: Input }],
    lines: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LineContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'line-content-loader',
                template: "<content-loader [animate]=\"animate\" [width]=\"lineWidth\" [height]=\"totalHeight\" [speed]=\"speed\" [preserveAspectRatio]=\"preserveAspectRatio\"\r\n  [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" [primaryOpacity]=\"primaryOpacity\" [secondaryColor]=\"secondaryColor\" [uniqueKey]=\"uniqueKey\">\r\n  <svg:rect *ngFor=\"let line of totalLines\" [attr.x]=\"lineX\" [attr.y]=\"getLineY(line)\" [attr.width]=\"lineWidth\"\r\n    [attr.height]=\"lineHeight\" />\r\n</content-loader>"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { 
    /** @ignore */
    setLineWidth: [{
            type: HostListener,
            args: ['window:resize']
        }], lineWidth: [{
            type: Input
        }], lineSeparation: [{
            type: Input
        }], lineHeight: [{
            type: Input
        }], lines: [{
            type: Input
        }] }); })();

/**
 * Este componente se utiliza para la declaración de un content loader de tipo card
 *
 * @example
 *      <card-content-loader
 *          [hasIcon]="true"
 *          [radius]="15"
 *          [lineSeparation]="15"
 *          [cardLines]="1"
 *          [lineWidth]="200"
 *          [lineHeight]="5">
 *      </card-content-loader>
 *
 */
class CardContentLoaderComponent extends ContentLoaderComponent {
    //#endregion
    //#region Constructor
    /** @ignore */
    constructor() {
        super();
        //#region Privates
        this._hasIcon = true;
        this._radius = 28;
        this._lineSeparation = 28;
        this._lineWidth = 200;
        this._lineHeight = 10;
        this._cardLines = 4;
        this._lineX = 0;
        this._iconY = 0;
        this._totalHeight = 0;
    }
    //#endregion
    //#region Hooks
    ngOnInit() {
        this._totalLines = Array(this.cardLines).fill(0).map((x, i) => i + 1);
        this._lineX = this.getLineX();
        this._totalHeight = this.getTotalHeight();
        this._iconY = this.getIconPositionY();
        this.width = this.lineX + this.lineWidth;
    }
    //#endregion
    //#region Functions
    getLineX() {
        let lineX = 0;
        if (this.hasIcon) {
            lineX = (this.radius * 2) + 10;
        }
        return lineX;
    }
    /** @ignore */
    getLineY(numberLine) {
        let lineY = 0;
        let position = numberLine;
        let totalLinesIsEven = this.cardLines % 2 === 0;
        let lineIsEven = numberLine % 2 === 0;
        if (totalLinesIsEven && lineIsEven) {
            position = -(position - 1);
        }
        else if (!totalLinesIsEven) {
            position = lineIsEven ? -position : position - 1;
        }
        lineY = ((this.lineSeparation + this.lineHeight) * position / 2) + this._iconY - this.lineHeight / 2;
        return lineY;
    }
    getIconPositionY() {
        let iconPositionY = 0;
        if (this.getLinesHeight() < this.radius * 2) {
            iconPositionY = this.radius;
        }
        else {
            iconPositionY = this.getLinesHeight() / 2;
        }
        return iconPositionY;
    }
    getTotalHeight() {
        let totalHeight = this.getLinesHeight();
        if (totalHeight < this.radius * 2) {
            totalHeight = this.radius * 2;
        }
        return totalHeight;
    }
    getLinesHeight() {
        return (this.lineSeparation * (this.cardLines - 1)) + (this.lineHeight * this.cardLines);
    }
    //#endregion
    //#region Getters & Setters
    /**
     * Permite consultar si el componente tiene el icono activado o no. De manera predeterminada está activado
     *
     * @return
     */
    get hasIcon() {
        return this._hasIcon;
    }
    /**
     * Permite activar o desactivar el icono del componente. De manera predeterminada está activado
     *
     * @param value Valor que activa o desactiva el icono
     * @return
     */
    set hasIcon(value) {
        this._hasIcon = value;
    }
    /**
     * Permite obtener la distancia de separación que hay entre lineas
     *
     * @return
     */
    get lineSeparation() {
        return this._lineSeparation;
    }
    /**
     * Permite definir la distancia de separación que hay entre lineas
     *
     * @param value La distancia de separación que hay entre lineas
     * @return
     */
    set lineSeparation(value) {
        this._lineSeparation = value;
    }
    /**
     * Permite obtener el radio del icono que tiene el componente
     *
     * @return
     */
    get radius() {
        return this._radius;
    }
    /**
     * Permite definir el radio del icono que tiene el componente
     *
     * @param value El radio del icono que tiene el componente
     * @return
     */
    set radius(value) {
        this._radius = value;
    }
    /**
     * Permite obtener el ancho de las lineas del componente
     *
     * @return
     */
    get lineWidth() {
        return this._lineWidth;
    }
    /**
     * Permite definir el ancho de las lineas del componente
     *
     * @param value El ancho de las lineas del componente
     * @return
     */
    set lineWidth(value) {
        this._lineWidth = value;
    }
    /**
     * Permite obtener la altura de las lineas del componente
     *
     * @return
     */
    get lineHeight() {
        return this._lineHeight;
    }
    /**
     * Permite definir la altura de las lineas del componente
     *
     * @param value La altura de las lineas del componente
     * @return
     */
    set lineHeight(value) {
        this._lineHeight = value;
    }
    /**
     * Permite obtener el número de lineas que tiene el componente
     *
     * @return
     */
    get cardLines() {
        return this._cardLines;
    }
    /**
     * Permite definir el número de lineas que tiene el componente
     *
     * @param value El número de lineas que tiene el componente
     * @return
     */
    set cardLines(value) {
        this._cardLines = value;
    }
    /** @ignore */
    get lineX() {
        return this._lineX;
    }
    /** @ignore */
    get iconY() {
        return this._iconY;
    }
    /** @ignore */
    get totalHeight() {
        return this._totalHeight;
    }
    /** @ignore */
    get totalLines() {
        return this._totalLines;
    }
}
CardContentLoaderComponent.ɵfac = function CardContentLoaderComponent_Factory(t) { return new (t || CardContentLoaderComponent)(); };
CardContentLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CardContentLoaderComponent, selectors: [["card-content-loader"]], inputs: { hasIcon: "hasIcon", lineSeparation: "lineSeparation", radius: "radius", lineWidth: "lineWidth", lineHeight: "lineHeight", cardLines: "cardLines" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 3, vars: 11, consts: [[3, "animate", "width", "height", "speed", "preserveAspectRatio", "primaryColor", "secondaryColor", "primaryOpacity", "uniqueKey"], [4, "ngIf"], [4, "ngFor", "ngForOf"]], template: function CardContentLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "content-loader", 0);
        ɵngcc0.ɵɵtemplate(1, CardContentLoaderComponent__svg_circle_1_Template, 1, 3, "circle", 1);
        ɵngcc0.ɵɵtemplate(2, CardContentLoaderComponent__svg_rect_2_Template, 1, 4, "rect", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("animate", ctx.animate)("width", ctx.width)("height", ctx.totalHeight)("speed", ctx.speed)("preserveAspectRatio", ctx.preserveAspectRatio)("primaryColor", ctx.primaryColor)("secondaryColor", ctx.secondaryColor)("primaryOpacity", ctx.primaryOpacity)("uniqueKey", ctx.uniqueKey);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.totalLines);
    } }, directives: [ContentLoaderComponent, ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2 });
/** @nocollapse */
CardContentLoaderComponent.ctorParameters = () => [];
CardContentLoaderComponent.propDecorators = {
    hasIcon: [{ type: Input }],
    lineSeparation: [{ type: Input }],
    radius: [{ type: Input }],
    lineWidth: [{ type: Input }],
    lineHeight: [{ type: Input }],
    cardLines: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CardContentLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'card-content-loader',
                template: "<content-loader [animate]=\"animate\" [width]=\"width\" [height]=\"totalHeight\" [speed]=\"speed\" [preserveAspectRatio]=\"preserveAspectRatio\"\r\n  [primaryColor]=\"primaryColor\" [secondaryColor]=\"secondaryColor\" [primaryOpacity]=\"primaryOpacity\" [uniqueKey]=\"uniqueKey\">\r\n  <svg:circle *ngIf=\"hasIcon\" [attr.cx]=\"radius\" [attr.cy]=\"iconY\" [attr.r]=\"radius\" />\r\n  <svg:rect *ngFor=\"let line of totalLines\" [attr.x]=\"lineX\" [attr.y]=\"getLineY(line)\" [attr.width]=\"lineWidth\" [attr.height]=\"lineHeight\" />\r\n</content-loader>"
            }]
    }], function () { return []; }, { hasIcon: [{
            type: Input
        }], lineSeparation: [{
            type: Input
        }], radius: [{
            type: Input
        }], lineWidth: [{
            type: Input
        }], lineHeight: [{
            type: Input
        }], cardLines: [{
            type: Input
        }] }); })();

class ContentLoaderModule {
}
ContentLoaderModule.ɵfac = function ContentLoaderModule_Factory(t) { return new (t || ContentLoaderModule)(); };
ContentLoaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ContentLoaderModule });
ContentLoaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContentLoaderModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ContentLoaderComponent,
                    FormContentLoaderComponent,
                    LineContentLoaderComponent,
                    CardContentLoaderComponent
                ],
                exports: [
                    ContentLoaderComponent,
                    FormContentLoaderComponent,
                    LineContentLoaderComponent,
                    CardContentLoaderComponent
                ],
                schemas: [CUSTOM_ELEMENTS_SCHEMA]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ContentLoaderModule, { declarations: function () { return [ContentLoaderComponent, FormContentLoaderComponent, LineContentLoaderComponent, CardContentLoaderComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ContentLoaderComponent, FormContentLoaderComponent, LineContentLoaderComponent, CardContentLoaderComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { CardContentLoaderComponent, ContentLoaderComponent, ContentLoaderModule, FormContentLoaderComponent, LineContentLoaderComponent };

